var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRoundedSwap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33366 5.33332L12.117 5.33332L10.4003 3.61666L11.3337 2.66666L14.667 5.99999L11.3337 9.33332L10.4003 8.38332L12.117 6.66666L7.33366 6.66666L7.33366 5.33332ZM1.33366 9.99999L4.66699 6.66666L5.60032 7.61666L3.88366 9.33332L8.66699 9.33332L8.66699 10.6667L3.88366 10.6667L5.60032 12.3833L4.66699 13.3333L1.33366 9.99999Z",
    fill: "#212121"
  })));
}

export default __webpack_public_path__ + "media/8ed7face.svg";
export { SvgRoundedSwap as ReactComponent };